import { render, staticRenderFns } from "./stats-export.vue?vue&type=template&id=222d6125&scoped=true&"
import script from "./stats-export.vue?vue&type=script&lang=js&"
export * from "./stats-export.vue?vue&type=script&lang=js&"
import style0 from "./stats-export.vue?vue&type=style&index=0&id=222d6125&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222d6125",
  null
  
)

component.options.__file = "stats-export.vue"
export default component.exports